export default "__VITE_PUBLIC_ASSET__9c01ca26__"